'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('react');
var PropTypes = _interopDefault(require('prop-types'));
var moment = _interopDefault(require('moment'));

/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Date(_ref) {
  var calendarFormat = _ref.calendarFormat,
      format = _ref.format,
      inputFormat = _ref.inputFormat,
      input = _ref.input,
      locale = _ref.locale;
  moment.locale(locale);

  if (!input) {
    return '';
  }

  if (calendarFormat) {
    return moment(input).calendar(null, calendarFormat);
  }

  return moment(input, inputFormat).format(format);
}
Date.propTypes = {
  /** */
  calendarFormat: PropTypes.shape(),

  /** */
  format: PropTypes.string,

  /** */
  inputFormat: PropTypes.string,

  /** */
  input: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** */
  locale: PropTypes.string
};
Date.defaultProps = {
  locale: '',
  format: 'L'
};

exports.moment = moment;
exports.default = Date;
